import type { AccountRole, AuthorizationStatus, AuthorizationStatusMeta } from "./AnalysisService.type";

export const AUTHORIZATION_STATUS_META: Record<AuthorizationStatus, AuthorizationStatusMeta> = {
	// biome-ignore lint/style/useNamingConvention: enum value keys
	SYNCED: { label: "Sikeres szinkron", badgeVariant: "success", measurementAction: "synced" },
	// biome-ignore lint/style/useNamingConvention: enum value keys
	PROCESSING: { label: "Folyamatban", badgeVariant: "warning", measurementAction: "in_progress" },
	// biome-ignore lint/style/useNamingConvention: enum value keys
	IN_PROGRESS: { label: "Folyamatban", badgeVariant: "warning", measurementAction: "in_progress" },
	// biome-ignore lint/style/useNamingConvention: enum value keys
	EXPIRED: { label: "Lejárt", badgeVariant: "danger", measurementAction: "expired" },
	// biome-ignore lint/style/useNamingConvention: enum value keys
	REVOKED: { label: "Visszavont", badgeVariant: "secondary", measurementAction: "revoked" },
	// CANCELLED has no value in the measurement spec; "cancelled" is our own and still awaits approval.
	// biome-ignore lint/style/useNamingConvention: enum value keys
	CANCELLED: { label: "Megszakítva", badgeVariant: "secondary", measurementAction: "cancelled" },
	// biome-ignore lint/style/useNamingConvention: enum value keys
	FAILED: { label: "Sikertelen", badgeVariant: "danger", measurementAction: "failed" },
};

const DOMESTIC_CURRENCY = "HUF";

export const ACCOUNT_ROLE_LABEL: Record<AccountRole | "FOREIGN_CURRENCY", string> = {
	// biome-ignore lint/style/useNamingConvention: enum value keys
	PRIMARY: "Főszámla",
	// biome-ignore lint/style/useNamingConvention: enum value keys
	SECONDARY: "Alszámla",
	// biome-ignore lint/style/useNamingConvention: enum value keys
	FOREIGN_CURRENCY: "Deviza számla",
};

export function accountRoleLabel(accountRole: string, currency?: string): string {
	if (currency && currency !== DOMESTIC_CURRENCY) {
		return ACCOUNT_ROLE_LABEL.FOREIGN_CURRENCY;
	}
	return ACCOUNT_ROLE_LABEL[accountRole as AccountRole] ?? accountRole;
}
